import { Dialog, DialogContent } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useAppData } from '../../../../../../context/AppDataContext';
import { useAlert } from '../../../../../../context/AlertContext';
import SelectProduct from '../../product/components/SelectProduct';
import voucherInItemServices from '../voucherInItemServices';
import CompanyLocationForm from '../../company/components/CompanyLocationForm';

function VoucherInItemForm({ voucherDetails, productList, callBack,isSecondary=false  }) {
    const { companyLocationDD,getCompanyLocationDD } = useAppData();
    const { AppAlert } = useAlert();

    const [selectedProduct, setSelectedProduct] = useState(null);
    const [item, setItem] = useState(null);
    const [errorList, setErrorList] = useState([]);

    // When a product is picked from the Autocomplete
    useEffect(() => {
        if (selectedProduct) {
            let _item = { ...selectedProduct };
            _item['qty'] = 1; 
            _item['locationId'] = 0;
            _item['stockId'] = 0; 
            _item['price'] = selectedProduct.cost || 0; 
            _item['isGstInclusive'] = false; 
            setItem(_item);
            setSelectedProduct(null);
        }
    }, [selectedProduct]);

    const handleItemChange = (key, value) => {
        setItem({ ...item, [key]: value });
    };

    // --- REAL-TIME CALCULATIONS ---
    const calculateValues = () => {
        if (!item) return { pricePerUnit: 0, amount: 0, gstAmount: 0, totalAmount: 0 };

        const qty = Number(item.qty) || 0;
        const enteredPrice = Number(item.price) || 0;
        const gstRate = Number(item.gstRate) || 0;

        let pricePerUnit = enteredPrice; 
        let amount = 0;
        let gstAmount = 0;
        let totalAmount = 0;

        if (item.isGstInclusive) {
            totalAmount = enteredPrice * qty;
            amount = totalAmount / (1 + (gstRate / 100));
            gstAmount = totalAmount - amount;
            pricePerUnit = amount / (qty || 1); 
        } else {
            amount = enteredPrice * qty;
            gstAmount = (amount * gstRate) / 100;
            totalAmount = amount + gstAmount;
            pricePerUnit = enteredPrice; 
        }

        return {
            pricePerUnit: Number(pricePerUnit.toFixed(2)),
            amount: Number(amount.toFixed(2)),
            gstAmount: Number(gstAmount.toFixed(2)),
            totalAmount: Number(totalAmount.toFixed(2))
        };
    };

    const { pricePerUnit, amount, gstAmount, totalAmount } = calculateValues();

    const validateItem = () => {
        let _errors = [];
        if (item.billingType === 1 && (!item.locationId || item.locationId === 0)) {
            _errors.push("Please select a Destination Warehouse");
        }
        if (Number(item.qty) <= 0) {
            _errors.push("Quantity must be greater than 0");
        }
        setErrorList(_errors);
        return _errors.length === 0;
    };

    const addItem = () => {
        if (!validateItem()) return;

        const payload = {
            ...item,
            voucherId: voucherDetails.id,
            productId: item.id,
            price: pricePerUnit, 
            amount: amount,
            gstAmount: gstAmount,
            totalAmount: totalAmount,
            voucherType: voucherDetails.voucherType,
            isSecondary:isSecondary
        };
        
        voucherInItemServices.save(payload).then(res => {
            AppAlert(res.msg);
            callBack(); 
            setItem(null); 
        }).catch(err => {
            AppAlert(err.msg || "Error adding item", "error");
        });
    };

    return (
        <>
            <SelectProduct 
                options={productList} 
                selectedProduct={selectedProduct} 
                setSelectedProduct={setSelectedProduct} 
            />

            <Dialog open={item !== null} onClose={() => setItem(null)} fullWidth maxWidth="md">
                <DialogContent>
                    {item && (
                        <div className="p-2">
                            {/* --- INPUT FORM SECTION --- */}
                            <table className='table table-borderless align-middle mb-4'>
                                <tbody>
                                    <tr>
                                        <th style={{ width: '30%' }}>Product</th>
                                        <td><strong className="text-primary fs-5">{item.title}</strong></td>
                                    </tr>
                                    <tr>
                                        <th>Purchase Price</th>
                                        <td>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light fw-bold">₹</span>
                                                <input 
                                                    className='form-control form-control-lg fw-semibold' 
                                                    type='number' 
                                                    value={item.price} 
                                                    onChange={(e) => handleItemChange("price", e.target.value)} 
                                                    placeholder="0.00"
                                                />
                                                <div className="input-group-text bg-light">
                                                    <div className="form-check form-switch mb-0 min-height-0">
                                                        <input 
                                                            className="form-check-input me-2" 
                                                            type="checkbox" 
                                                            id="gstInclusiveCheck"
                                                            checked={item.isGstInclusive || false}
                                                            onChange={(e) => handleItemChange("isGstInclusive", e.target.checked)} 
                                                            style={{ cursor: 'pointer', transform: 'scale(1.1)' }}
                                                        />
                                                        <label 
                                                            className="form-check-label small user-select-none fw-bold text-dark" 
                                                            htmlFor="gstInclusiveCheck"
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            Inclusive GST
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>GST %</th>
                                        <td>
                                            <div className="input-group" style={{ maxWidth: '200px' }}>
                                                <input className='form-control' type='number' value={item.gstRate} 
                                                    onChange={(e) => handleItemChange("gstRate", e.target.value)} />
                                                <span className="input-group-text">%</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Quantity Received</th>
                                        <td>
                                            <input className='form-control' type='number' value={item.qty} 
                                                onChange={(e) => handleItemChange("qty", e.target.value)} style={{ maxWidth: '200px' }} />
                                        </td>
                                    </tr>
                                    {item.billingType === 1 && (
                                        <tr>
                                            <th>Receive at Location</th>
                                            <td>
                                                <select className='form-control' value={item.locationId} 
                                                    onChange={(e) => handleItemChange("locationId", e.target.value)}>
                                                    <option value={0}>--- Select Warehouse ---</option>
                                                    {companyLocationDD.map(loc => (
                                                        <option key={loc.value} value={loc.value}>{loc.label}</option>
                                                    ))}
                                                </select>
                                                <CompanyLocationForm callBack={getCompanyLocationDD} />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>

                            {/* --- SEPARATE LIVE BREAKDOWN SECTION --- */}
                            <div className="card border-0 bg-light shadow-sm mb-4">
                                <div className="card-header bg-secondary text-white fw-bold py-2 px-3 small text-uppercase tracking-wider">
                                    Calculation Breakdown Summary
                                </div>
                                <div className="card-body p-0">
                                    <table className="table table-sm mb-0 align-middle">
                                        <tbody>
                                            <tr className="border-bottom">
                                                <th className="ps-3 py-2 text-secondary fw-normal" style={{ width: '40%' }}>Item Base Price (Excl. GST)</th>
                                                <td className="pe-3 text-end fw-semibold text-dark">₹ {pricePerUnit}</td>
                                            </tr>
                                            <tr className="border-bottom">
                                                <th className="ps-3 py-2 text-secondary fw-normal">Taxable Value (Qty × Base Price)</th>
                                                <td className="pe-3 text-end fw-semibold text-dark">₹ {amount}</td>
                                            </tr>
                                            <tr className="border-bottom">
                                                <th className="ps-3 py-2 text-secondary fw-normal">GST Amount Generated</th>
                                                <td className="pe-3 text-end fw-semibold text-danger">+ ₹ {gstAmount}</td>
                                            </tr>
                                            <tr className="bg-white table-active">
                                                <th className="ps-3 py-3 text-primary fs-5 fw-bold">Total Net Amount</th>
                                                <td className="pe-3 text-end text-primary fs-5 fw-bold">₹ {totalAmount}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* --- ERROR MESSAGE & ACTION BUTTONS BAR --- */}
                            <div className="d-flex justify-content-between align-items-center pt-2 border-top">
                                <div className="flex-grow-1 me-3">
                                    {errorList.map((err, i) => (
                                        <div key={i} className='text-danger small fw-semibold'>• {err}</div>
                                    ))}
                                </div>
                                <button className='btn btn-success  px-4 ' onClick={addItem}>
                                    Add Item
                                </button>
                            </div>
                        </div>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
}

export default VoucherInItemForm;